<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M10.46 15.5c.42.42.94.61 1.58.6.64-.03 1.1-.26 1.38-.7l5.6-8.4-8.4 5.6c-.43.3-.67.75-.7 1.36-.05.61.14 1.12.55 1.54ZM5.11 20c-.37 0-.7-.07-1-.23-.32-.16-.56-.4-.75-.71a11.2 11.2 0 0 1-1-2.45 9.85 9.85 0 0 1 .44-6.5 10.18 10.18 0 0 1 2.14-3.19A10.18 10.18 0 0 1 12.02 4c1.38 0 2.65.26 3.86.78a10.2 10.2 0 0 1 5.3 5.24 10.1 10.1 0 0 1-.52 9.04c-.18.33-.43.56-.74.72-.31.16-.65.24-1.01.24H5.1Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
